import * as React from 'react';
import { Dispatch } from 'redux';
import { useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { CardImg, Col, Input, CardBody, Button, Row } from "reactstrap";
import { languageAction } from '../../actions/languageAction';
import { channelAction } from '../../actions/channelAction';
import { userAction } from '../../actions/userAction';
import { DABDropDown, DABTextBox, DABButton, DABBackToList, LoadingSpinnerModal } from '../../components/dab';
import { showAlert, exceptionHandler } from "../common/functions";
import NoImage from '../../assets/images/noimage.png'
import { getIsAdminLogged, getLoggedUserId } from '../../services/selectors/Accounts';
import { UserService } from '../../services/api/userService';
import is from 'date-fns/locale/is/index';

interface IUsersProps {
	dispatch: Dispatch<any>;
	channelData: any;
	userData: any;
	callback: any;
	id: number;
	languageData: any;
}

const UserDetail: React.SFC<IUsersProps> = ({ dispatch, channelData, userData, id, languageData, callback }) => {

	const channel = { title: "", id: 0, description: "", isActive: false, checked: false, iconImage: "", isAdmin: false, disabled:true };
	const userInput = {
		languageCode: "",
		userId: -1,
		isActive: false,
		isAdmin: false,
		authorChannelIds: [0],
		roleCodes: [""],
		password: "",
		firstName: "",
		lastName: "",
		userName: "",
		cnfPassword: "",
		roles: '',
		email:''
	}

	const userAccountInput = {
		languageCode: "",
		userId: -1,
		firstName: "",
		lastName: "",
	}
	const fromPath = sessionStorage.getItem('fromPath');
	const history = useHistory();

	const [isRoleLoaded, setIsRoleLoaded] = useState(false);
	const [isChannelLoaded, setIsChannelLoaded] = useState(false);
	const initialValue = [{ text: "", value: "", checked: false, disabled: false }];
	const [channelList, setChannelList] = useState([channel]);
	const [rolesList, setRolesList] = useState(initialValue);
	const [frmInput, setFrmInput] = useState(userInput);
	const [formSubmit, setformSubmit] = useState(false);
	const [isPreviewPage, setIsPreviewPage] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [isDetailLoaded, setIsDetailLoaded] = useState(false);
	const [isErrorOnPage, setIsErrorOnPage] = useState(false);
	const [languageName, setLanguageName] = useState("");
	const [langList, setLangList] = useState([{ text: "English", value: "en", checked: false }]);
	const [isLangListLoaded, setIsLangListLoaded] = useState(false);
	const [isAllDataLoaded, setIsAllDataLoaded] = useState(false);
	const [isAdminLogged, setIsAdminLogged] = useState(false);
	const [isEditable, setIsEditable] = useState(false);
	const [loggedUserId, setLoggedUserId] = useState(0);
	const [changeFlag, setChangeFlag] = useState(false);
	const [isUserCheckInit, setIsUserCheckInit] = useState(false);
	const [isUserNameExists, setIsUserNameExists] = useState(false);
	const [isDirty, setIsDirty] = useState<boolean>(false);
	const [isAdminEdit, setIsAdminEdit] = useState(false);
	
	React.useEffect(() => {
		dispatch(channelAction.channelGetAll({ sortDirection: "asc" }));
		dispatch(userAction.userRoleGetByFilter());
		dispatch(languageAction.languageGetByfilter());
		setLoggedUserId(getLoggedUserId());
		setIsAdminLogged(getIsAdminLogged());
	}, []);

	if (userData) {
		if (!isUserCheckInit && userData.isError && !isErrorOnPage) {
			if (userData.status === 'Unauthorized') {
				history.push({ pathname: '/401', state: 'user' });
			} else if (Number(userData.statusCode) === 400 ) {
				history.push("/404");
			} else {
				showAlert(userData.status, true);
			}
			userData.isError = false;
			setIsErrorOnPage(true);
			setShowModal(false);
		}

		if (formSubmit && userData.isSuccess && !userData.isError) {
			window.localStorage.setItem('alertMessage', userData.status);
			fromPath == '/account' ? window.location.href = '/' : window.location.href='/user';
		}

		if (!isAllDataLoaded && isChannelLoaded && isRoleLoaded && isLangListLoaded && id > 0)
		{
			if (getIsAdminLogged())
			{
				if (loggedUserId == id) {
					setIsAdminEdit(false);
				}
				else {
					setIsAdminEdit(true);
				}
			}

			if (getIsAdminLogged() || loggedUserId == id)
			{
				dispatch(userAction.userGetDetail(id));
				setIsAllDataLoaded(true);
			}
			else {
				window.location.href = "/401";
			}
		}

		if (!isUserCheckInit && userData.isDetailComplete) {
			if (!isDetailLoaded && userData.item && userData.isHaveAdminRole) {				
				setFrmInput(userData.item);
				setIsDetailLoaded(true);
				if (isAdminLogged || userData.item.userId == loggedUserId) {
					setIsEditable(true);
					callback(userData.item.firstName + " " + userData.item.lastName);
				};
				if (userData.item.channelIds) {
					userData.item.channelIds.split(',').forEach((obj) => {
						var index = channelList.findIndex(x => x.id === parseInt(obj));
						if (index > -1) {
							channelList[index].checked = true;
						}
					});
					setChannelList(channelList);
					setChangeFlag(!changeFlag)
				}

				if (userData.item.roles != "") {
					userData.item.roles.split(',').forEach((obj) => {
						var index = rolesList.findIndex(x => x.value.toString().toLowerCase() === obj.toLowerCase());
						if (index > -1) { rolesList[index].checked = true; }
						if (userData.item.roles.includes("Channel")) {
							rolesList.forEach(data => {
								if (data.value === "Episode") {
									data.checked = true
									data.disabled = true
								}
							})
						}
					});
					setRolesList(rolesList);
				}
			}

			if (!isDetailLoaded && userData.item && !userData.isHaveAdminRole) {
				history.push("/404")
			}
			if (showModal) {
				setShowModal(false);
			}
			userData.isSuccess = false;
		}
	}

	if (!isChannelLoaded && !channelData.isLoading) {
		if (channelData.isListSuccess) {
			channelData.isListSuccess = false;
			setIsChannelLoaded(true);

			if (channelList && channelList.length <= 1) {
				var list: any[] = [];
				channelData.items.forEach((data) => {
					var item1 = {
						title: data.title,
						id: data.channelId,
						description: data.descriptionHtml,
						iconImage: data.iconImage,
						checked: false,
						disabled:true
					};
					list.push(item1);
				});
				setChannelList(list);
			}			
		}
	}

	if (!isRoleLoaded && !userData.isLoading) {
		if (userData.isRoleListSuccess) {
			setIsRoleLoaded(true);
			if (rolesList && rolesList.length <= 1) {
				var list0: any[] = [];
				userData.rolesList.forEach((data) => {
					if (data.roleCode === 'Channel') return;
					list0.push({ text: data.roleName, value: data.roleCode, checked: false, disabled: false });
				});
				setRolesList(list0);
			}			
		}
	}

	if (langList && !isLangListLoaded) {
		if (languageData.items.length > 0) {
			var list1: any[] = [];
			languageData.items.forEach((data) => {
				list1.push({ text: data.name, value: data.languageCode, checked: true });
			});
			setLangList(list1);
			list1 && setLanguageName(list1[0].text);

			setFrmInput({
				...frmInput,
				languageCode: langList[0].value
			});
			setIsLangListLoaded(true);
			setShowModal(false);
		}
	}

	if (isUserCheckInit && userData.isDetailComplete)
	{
		setIsUserCheckInit(false);

		if (userData.isSuccess && userData.item) {
			setIsUserNameExists(true);
		}
		else
		{
			setIsUserNameExists(false);
		}
		userData.isDetailComplete = false;
		userData.isSuccess = false;
		userData.isError = false;

		if (showModal) {
			setShowModal(false);
		}
	}

	const handleInputChange = (event) => {
		let name = event.target.name;
		let value = event.target.value;
		if (name === 'userName') {
			var val = value.toLowerCase();
			setFrmInput({
				...frmInput,
				[name]: val,
			});
		} else {
			setFrmInput({
				...frmInput,
				[name]: value,
			});
		}
		
		setIsDirty(true);
	};

	const handleChangeChannel = (event, value) => {
		channelList.forEach((data) => {
			if (data.id === value) {
				data.checked = event.target.checked;
			}
		});
		setChannelList(channelList);
		setChangeFlag(!changeFlag);
	};

	const handleLoadShowModal = (value: boolean) => {
		setShowModal(value);
	};

	const handleLanguageChange = (event) => {
		langList && langList.forEach((data: any) => {
			if (data.value === event.target.value) {
				setLanguageName(data.text);
			}
		});
	}

	const handleRoleChange = (event, roleCode) => {
		if (roleCode === "Channel") {
			rolesList.forEach((data) => {
				if (data.value === "Channel") {
					data.checked = event.target.checked;
				} else if (data.value === "Episode") {
					data.checked = event.target.checked
					data.disabled = event.target.checked
				}
			});
			channelList.forEach((data) => {
				if (event.target.checked) {
					data.disabled = false
				} else {
					data.checked = false
					data.disabled = true
				}

			})
		} else if (roleCode === "Episode") {
			rolesList.forEach((data) => {
				if (data.value === roleCode) {
					data.checked = event.target.checked;
				}
			})
			channelList.forEach((data) => {
				if (event.target.checked) {
					data.disabled = false
				} else {
					data.checked = false
					data.disabled = true
				}

			})
		} else {
			rolesList.forEach((data) => {
				if (data.value === roleCode) {
					data.checked = event.target.checked;
				}
			});
		}
		setChangeFlag(!changeFlag);
		setIsDirty(true);
	}

	const handleBackClick = (event) => {
		event.preventDefault();
		if (isPreviewPage) {
			setIsPreviewPage(false);
		}
		else if (!isPreviewPage) {
			history.goBack();
		}

	}

	const handleNextClick = async (event) => {
		event.preventDefault();
		var email = frmInput.userName
		var filter = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		if (!filter.test(email)) {
			showAlert("Please enter valid email address", true)
			return false;
		}
		if (frmInput.password != frmInput.cnfPassword) {
			showAlert("The two passwords that you entered do not match!", true)
			return false;
		}

		// Re-check the email against the server here too, and wait for the result,
		// so a fast/duplicate click can't slip past this using a stale isUserNameExists value.
		setShowModal(true);
		let userNameExists = isUserNameExists;
		try {
			const res = exceptionHandler(await UserService.userGetDetail(-1, email));
			userNameExists = !!(res.status && res.data && res.data.user);
		} catch {
			userNameExists = false;
		}
		setIsUserNameExists(userNameExists);
		setShowModal(false);

		if(!userNameExists)
		{
			const roleCodes = rolesList.filter(r => r.checked === true)
			const communityUser = rolesList.filter(r => r.checked === true && r.value==="Community")
			const channels = channelList.filter(ch => ch.checked === true)

			if (!isPreviewPage) {
				if (!frmInput.isAdmin && roleCodes.length <= 0) {
					showAlert("Select atleast one role", true)
				} else if (!frmInput.isAdmin &&
					(channels.length <= 0 && communityUser.length < 1 && roleCodes.length === 1) ||
					(channels.length <= 0 && roleCodes.length>1)) {
					showAlert("Select atleast one channel", true)
				} else {
					setIsPreviewPage(true);
					callback("Review Create New");
				}
			}
			else if (isPreviewPage) {
				handleSubmit(event);
				}
		}
	}

	const handleSubmit = (event) => {
		event.preventDefault();
		var inp = frmInput;
		setformSubmit(true);
		setShowModal(true);
		setIsErrorOnPage(false);	

		if (isAdminLogged) {
			var roleCodes: any[] = [];
			var channelIds: any[] = [];

			if (!frmInput.isAdmin) {
				rolesList.forEach((data) => {
					if (data.checked) {
						roleCodes.push(data.value);
					}
				});
				if (inp.userId > 0 && frmInput.roles) {
					const existingRoles = frmInput.roles.split(',').map((r) => r.trim()).filter(Boolean);
					if (
						existingRoles.some((r) => r.toLowerCase() === 'channel') &&
						!roleCodes.some((r) => String(r).toLowerCase() === 'channel')
					) {
						roleCodes.push('Channel');
					}
				}
				channelList.forEach((data) => {
					if (data.checked) {
						channelIds.push(data.id);
					}
				});

				if (roleCodes.length > 0
					&& (channelIds.length > 0
						|| roleCodes[0].toLowerCase() === "community")) {
					inp.authorChannelIds = channelIds;
					inp.roleCodes = roleCodes;
					inp.languageCode = frmInput.languageCode;
					dispatch(userAction.userSave({ user: inp }));
				} else {
					if (roleCodes.length <= 0) {
						showAlert("Please select a role", true)
					} else if (channelIds.length <= 0 && roleCodes[0].toLowerCase() != "community") {
						showAlert("Please select atleaset one channel", true)
					}
				}
			} else {
				channelList.forEach((data) => { channelIds.push(data.id); });
				inp.authorChannelIds = channelIds;
				inp.roleCodes = roleCodes;
				inp.languageCode = frmInput.languageCode;
				dispatch(userAction.userSave({ user: inp }));
			}

			if (inp.userId > 0) {
				inp.password = "***";
			}
		}
		else {
			var userAccountInp = userAccountInput;
			userAccountInp.userId = inp.userId;
			userAccountInp.firstName = inp.firstName;
			userAccountInp.lastName = inp.lastName;
			userAccountInp.languageCode = inp.languageCode;
			dispatch(userAction.userAccountUpdate({ user: inp }));
		};
	};

	const handleAdminChange = (e) => {		
		setFrmInput({ ...frmInput, isAdmin: e.target.checked, roleCodes: [""] });
		rolesList.forEach((data) => {
			data.checked = false,
			data.disabled = e.target.checked ? true : false
		});
		channelList.forEach((data) => {
			data.checked = e.target.checked ? true : false,
			data.disabled = true
		})
		setRolesList(rolesList);
		setChannelList(channelList);
		setChangeFlag(!changeFlag);
		setIsDirty(true);
	}
	const handleCheckIfUserNameExists = (e) => {
		console.log('chheck user name exist')
		e.preventDefault();
		var inpUserName = e.target.value;
		setFrmInput({ ...frmInput, userName: inpUserName });
		setIsUserCheckInit(true);
		setShowModal(true);
		dispatch(userAction.userGetDetail(-1, inpUserName));
	}
	const handleActive = (e) => {
		setFrmInput({ ...frmInput, isActive: !frmInput.isActive })
		setIsDirty(true);
	}
	React.useEffect(() => {
		const eventHandler = (event: BeforeUnloadEvent) => {
			var sessionExpiry = window.localStorage.getItem('SESSIONEXPIRY');
			const inSession = Date.now() < Number(sessionExpiry)
			if (!formSubmit && inSession) {
				event.preventDefault();
				event.returnValue = "";
			}
		};
		if (isDirty) { window.addEventListener("beforeunload", eventHandler) }
		return () => { window.removeEventListener("beforeunload", eventHandler) };
	}, [isDirty && !formSubmit, changeFlag])
	return (
		<div className="user-detail">
			{showModal || userData.isLoading && (<LoadingSpinnerModal isShowModal={showModal || userData.isLoading} modalChange={handleLoadShowModal} />)}
			<div className='card-box'>
				{!isDetailLoaded && !isPreviewPage && isAdminLogged && (
					<form onSubmit={handleNextClick} className="create-form">
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="isActive" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblIsActive">Active</label>
							<div className={["col-sm-5"].join(" ")}>
								<div className="form-check form-switch" data-testid="isActiveContainer">
									<Input className="form-check-switch" type="checkbox" id="isActive" name="isActive"
										checked={frmInput.isActive} onChange={(e) => handleActive(e) } />
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="isAdmin" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblIsAdmin">Administrator</label>
							<div className={["col-sm-5"].join(" ")}>
								<div className="form-check form-switch" data-testid="isAdminContainer">
									<Input className="form-check-switch " type="checkbox" id="isAdmin" name="isAdmin"
										checked={frmInput.isAdmin} onChange={(e) =>handleAdminChange(e) } />
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="firstName" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblFirstName">First Name</label>
							<div data-testid="firstNameContainer" className={["col-sm-5"].join(" ")}>
								<DABTextBox type="text" id="firstName" maxLength={100} isRequired={true} isHover={false}
									onChange={(event) => { handleInputChange(event) }} value={frmInput.firstName} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="lastName" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblLastName">Last Name</label>
							<div data-testid="lastNameContainer" className={["col-sm-5"].join(" ")}>
								<DABTextBox type="text" id="lastName" isRequired={true} maxLength={100}  isHover={false}
									onChange={(event) => { handleInputChange(event) }} value={frmInput.lastName} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="email" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblEmail">Email</label>
							<div data-testid="userNameContainer" className={["col-sm-5"].join(" ")}>
								<DABTextBox type="text" id="userName" maxLength={100} isRequired={true} isHover={false}
									onChange={(event) => { handleInputChange(event) }} value={frmInput.userName}
									onBlur={(event) => { handleCheckIfUserNameExists(event); }}/>
								<div style={{ display: `${isUserNameExists ? '' : 'none'}` }}><label data-testid="userNameErr" className="text-danger">Typed User Name / Email Already Exists.</label></div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="password" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblPassword">Password</label>
							<div data-testid="passwordContainer" className={["col-sm-5"].join(" ")}>
								<DABTextBox type="password" id="password" isRequired={true} isHover={false}
									onChange={(event) => { handleInputChange(event) }} value={frmInput.password} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="cnfPassword" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblRepeatPassword">Retype Password</label>
							<div data-testid="cnfPasswordContainer" className={["col-sm-5"].join(" ")}>
								<DABTextBox type="password" id="cnfPassword" isRequired={true} isHover={false}
									onChange={(event) => { handleInputChange(event) }} value={frmInput.cnfPassword} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="languageCode" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblLanguage">Language</label>
							<div data-testid="languageContainer" className={["col-sm-5"].join(" ")}>
								<DABDropDown id="languageCode" value={frmInput.languageCode} isRequired={true} isHover={false}
									onChange={(event) => { handleInputChange(event); handleLanguageChange(event); }} options={langList} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="role" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblRoles">Roles</label>
							<div className={["col-sm-6 row mb-2 ml-2"].join(" ")}>
								{
									rolesList && rolesList.map((data: any) =>
										<div className={["col-sm-6"].join(" ")} data-testid={"rolesContainer-"+ data.value}>
											<Input checked={data.checked} key={data.value + "roleCheckbox"} type="checkbox" name={data.value}
												onChange={(event) => handleRoleChange(event, data.value)} disabled={data.disabled} />
											<label className={["col-sm-10"].join(" ")}> {data.text}</label>
										</div>
									)
								}
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="channel" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblChannelAccess">Channel Access</label>
							<div className={["col-sm-9 row mb-2"].join(" ")}>
								{
									channelList && channelList.map((data: any,index) =>
										<Col key={data.id} lg="2">
											<CardImg className='card-box-img'
												src={data.iconImage}
												alt={data.title}
												onError={(e: any) => { e.target.src = NoImage }}
											/>
											<CardBody className={data.isActive ? 'card-body' : 'card-body-disabled'}>
												<Input data-testid={`channel-${data.id}`} checked={data.checked} type="checkbox" 
													onChange={(event) => { handleChangeChannel(event, data.id); }} name={data.text} disabled={data.disabled}>
													</Input>
												<span> {data.title}</span>
												</CardBody>
										</Col>
									)}
							</div>
						</div>
						<Row className="ud-buttons">
							<Col lg="3" data-testid="cancelButtonContainer">
								<Button className="" onClick={(e) => { handleBackClick(e); }}>CANCEL</Button>
							</Col>
							<Col lg="2" data-testid="nextButtonContainer">
								<Button type="submit" className="btn-submit-frm" value="Next">NEXT</Button>
							</Col>
						</Row>
					</form>
				)}

				{isPreviewPage && !isDetailLoaded && isAdminLogged &&(
					<form onSubmit={handleNextClick} className="preview-form">
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="isActive" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblPrevIsActive">Active</label>
							<div className={["col-sm-5"].join(" ")}>
								<div className={["col-sm-5 col-form-label-value"].join(" ")} data-testid="prevIsActive">
									{frmInput.isActive ? "Yes" : "No"}
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="isAdmin" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblPrevIsAdmin">Administrator</label>
							<div className={["col-sm-5"].join(" ")}>
								<div className={["col-sm-5 col-form-label-value"].join(" ")} data-testid="prevIsAdmin">
									{frmInput.isAdmin ? "Yes" : "No"}
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="firstName" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblPrevFirstName">First Name</label>
							<div data-testid="prevFirstName" className={["col-sm-5"].join(" ")}>
								{frmInput.firstName}
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="lastName" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblPrevLastName">Last Name</label>
							<div data-testid="prevLastName" className={["col-sm-5"].join(" ")}>
								{frmInput.lastName}
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="userName" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblPrevEmail">Email</label>
							<div data-testid="prevUserName" className={["col-sm-5"].join(" ")}>
								{frmInput.userName}
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="password" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblPrevPassword">Password</label>
							<div className={["col-sm-5"].join(" ")} data-testid="prevPassword">
								**********
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="languageName" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblPrevLanguage">Language</label>
							<div className={["col-sm-5"].join(" ")} data-testid="prevLanguage">
								{languageName}
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="role" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblPrevRoles">Roles</label>
							<div className={["col-sm-5"].join(" ")} data-testid="prevRoles">
								{frmInput.isAdmin ? "Admin":
									rolesList && rolesList.map((data: any) =>
										data.checked && <label>{data.text};</label>
									)}
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="channel" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblPrevChannelAccess">Channel Access</label>
							<div className={[frmInput.isAdmin ? "col-sm-5" : "col-sm-9 row mb-2"].join(" ")} data-testid="prevChannels">
								{frmInput.isAdmin? "All Channels":
									channelList && channelList.map((data: any) =>
										<>
											{data.checked &&
												<Col key={"ChannelidV" + data.channelId} lg="2">
												<CardImg className='card-box-img' data-testid="prevChannelImage"
													src={data.iconImage}
														alt={data.title}
														onError={(e: any) => { e.target.src = NoImage }}
													/>
													<CardBody className={data.isActive ? 'card-body' : 'card-body-disabled'} data-testid="prevChannelName">
														<span> {data.title}</span>
													</CardBody>
												</Col>
											}
										</>
									)}
							</div>
						</div>
						<Row className="ud-buttons">
							<Col lg="3" data-testid="backButtonContainer">
								<Button className="" onClick={(e) => { handleBackClick(e); }}>BACK</Button>
							</Col>
							<Col lg="2" data-testid="createButtonContainer">
								<Button className="btn-submit-frm" onClick={(e) => { handleNextClick(e); }}>CREATE</Button>
							</Col>
						</Row>
					</form>
				)}

				{isDetailLoaded && isEditable &&(
					<form onSubmit={handleSubmit} className="update-form">
						<DABBackToList onClick={(e) => { handleBackClick(e); }} />
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="isActive" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblEditIsActive">Active</label>
							<div className={["col-sm-5"].join(" ")}>
								<div className="form-check form-switch" data-testid="isActiveContainer">
									<Input className="form-check-switch " type="checkbox" id="isActive" name="isActive" disabled={!isAdminEdit}
										defaultChecked={frmInput.isActive} onChange={(e) => handleActive(e)} />
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="isAdmin" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblEditIsAdmin">Administrator</label>
							<div className={["col-sm-5"].join(" ")}>
								<div className="form-check form-switch" data-testid="isAdminContainer">
									<Input className="form-check-switch " type="checkbox" id="isAdmin" name="isAadmin" disabled={!isAdminEdit}
										checked={frmInput.isAdmin} onChange={(e) => handleAdminChange(e)} />
								</div>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="firstName" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblEditFirstName">First Name</label>
							<div data-testid="firstNameContainer" className={["col-sm-5"].join(" ")}>
								<DABTextBox type="text" id="firstName" maxLength={100} isRequired={true} isHover={true}
									onChange={(event) => { handleInputChange(event) }} value={frmInput.firstName} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="lastName" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblEditLastName">Last Name</label>
							<div data-testid="lastNameContainer" className={["col-sm-5"].join(" ")}>
								<DABTextBox type="text" id="lastName" maxLength={100} isRequired={true} isHover={true} 
									onChange={(event) => { handleInputChange(event) }} value={frmInput.lastName} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="userName" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblEditEmail">Email</label>
							<div data-testid="userNameContainer" className={["col-sm-5"].join(" ")}>
								<DABTextBox type="text" id="userName" maxLength={100} isRequired={true} isHover={true}
									onChange={(event) => { handleInputChange(event) }} value={frmInput.email} readonly={ true } />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="languageCode" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblEditLanguage">Language</label>
							<div data-testid="languageContainer" className={["col-sm-5"].join(" ")}>
								<DABDropDown id="languageCode" value={frmInput.languageCode} isRequired={true} isHover={true}
									onChange={(event) => { handleInputChange(event); handleLanguageChange(event); }} options={langList} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="role" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblEditRoles">Roles</label>
							<div className={["col-sm-6 row mb-2 ml-2"].join(" ")}>
								{rolesList && rolesList.map((data: any) =>
									<div className={["col-sm-6"].join(" ")} data-testid={"rolesContainer-" + data.value}>
										<Input key={data.value + "roleCheckboxU"} type="checkbox"
											checked={data.checked}
											onChange={(event) => handleRoleChange(event, data.value)}
											name={data.value} value={data.checked}
											disabled={!isAdminLogged || frmInput.isAdmin ? true : data.disabled}/>
										<label className={["col-sm-10"].join(" ")}> {data.text}</label>
									</div>)}
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="channel" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblEditChannelAccess">Channel Access</label>
							<div className={["col-sm-9 row mb-2"].join(" ")}>
								{channelList && channelList.map((data: any,index) =>
									<Col key={data.channelId} lg="2">
										<CardImg className='card-box-img'								
											src={data.iconImage}
											alt={data.title}
											onError={(e: any) => { e.target.src = NoImage }}
										/>
										<CardBody className={data.isActive ? 'card-body' : 'card-body-disabled'}>
											<Input type="checkbox" data-testid={`channel-${data.id}`}
												checked={frmInput.isAdmin ? true : data.checked}
												onChange={(event) => { handleChangeChannel(event, data.id); }}
												className='col-sm-2 col-form-label' name={data.text} value={data.channelId}
												disabled={!isAdminLogged && (rolesList.filter(role => role.value != 'Community').every(role => role.checked === false) || !isAdminEdit) ? true :
													frmInput.isAdmin ? true : (rolesList.filter(role => role.value != 'Community').every(role => role.checked === false)) ? true : false}>
											</Input>
											<span> {data.title}</span>
										</CardBody>
									</Col>)}
							</div>
						</div>
						<Row className="ud-buttons">
							<Col data-testid="saveChangesButtonContainer" lg="12" className={["pull-right"].join(" ")}>
								<DABButton id="Submit" className="btn-submit-frm" value="SAVE CHANGES"></DABButton>
							</Col>
						</Row>
					</form>
				)}
			</div>
		</div>
	)
}

const mapStateToProps = (state: any) => {
	const { channelData, userData, languageData } = state;
	return {
		channelData, userData, languageData
	};
};

export default connect(mapStateToProps)(UserDetail);
